import { Code } from 'constants/keyboard';
import { useEventListener } from 'hooks/useEventListener';
import { memo } from 'react';
import { useEditor as useInfographEditor } from 'widgets/sdk';

import { WidgetState } from '../common/TextBasedWidgets.types';
import { TableWidgetKeyboardShortcutsProps } from './TableWidget.types';

// custom table widget keyboard shortcuts
export const TableWidgetKeyboardShortcuts = memo(
  ({ setWidgetState, widgetState, editor }: TableWidgetKeyboardShortcutsProps) => {
    const { setWidgetToolbarFocus, isElementInToolbarFocused } = useInfographEditor();

    const onKeyDown = (e: KeyboardEvent | Event) => {
      const isToolbarFocused = isElementInToolbarFocused();

      const isEditable = widgetState === WidgetState.Edit;
      const isActive = widgetState === WidgetState.Active;
      const isDefault = widgetState === WidgetState.Default;

      const event = e as KeyboardEvent;
      const code = event.code as Code;

      const isCtrl: boolean = event.ctrlKey;
      const isMod: boolean = event.metaKey || isCtrl;
      const isAlt: boolean = event.altKey;

      switch (code) {
        case Code.Escape:
          if (isEditable) {
            // Return focus to the editor
            if (isToolbarFocused) {
              return editor.chain().focus();
            } else {
              return setWidgetState(WidgetState.Active);
            }
          }
          break;
        case Code.Enter:
          // Enter edit mode
          if (isActive || isDefault) {
            return setWidgetState(WidgetState.Edit);
          }
          break;
        case Code.T:
          if (isMod && isAlt && isEditable) return setWidgetToolbarFocus();
          break;
      }
    };

    useEventListener('keydown', onKeyDown);

    return <></>;
  },
);
TableWidgetKeyboardShortcuts.displayName = 'TableWidgetKeyboardShortcuts';
